import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import TrustedNumberConfirmationModal from '../../components/security/TrustedNumberConfirmationModal';
import { toggleDeleteTrustedNumberModal } from '../../actions/AppActions';
import { deleteTrustedPhoneNumber } from '../../actions/security/SecurityPhoneNumberActions';
import { getIsDeleteTrustedNumberModal } from '../../selectors/InteractionSelector';
import { deleteTrustedPhoneNumberKey } from '../../constants/security/TrustedNumberModalKeys';
import { getDeletePhoneError } from '../../selectors/ErrorSelector';
import { jsx as _jsx } from "react/jsx-runtime";
class DeleteTrustedNumberModalContainer extends Component {
  render() {
    if (this.props.deleteTrustedNumberModalOpen) {
      return /*#__PURE__*/_jsx(TrustedNumberConfirmationModal, {
        closeModal: this.props.closeModal,
        trustedNumberAction: this.props.trustedNumberAction,
        modalKey: this.props.modalKey,
        deleteError: this.props.deleteError
      });
    }
    return null;
  }
}
DeleteTrustedNumberModalContainer.propTypes = {
  deleteTrustedNumberModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  trustedNumberAction: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  deleteError: PropTypes.bool
};
const mapStateToProps = state => {
  return {
    deleteTrustedNumberModalOpen: getIsDeleteTrustedNumberModal(state),
    modalKey: deleteTrustedPhoneNumberKey,
    deleteError: getDeletePhoneError(state)
  };
};
export default connect(mapStateToProps, {
  closeModal: toggleDeleteTrustedNumberModal,
  trustedNumberAction: deleteTrustedPhoneNumber
})(DeleteTrustedNumberModalContainer);